export default () => ({
    unreadCount: 0,
    chats: undefined,
    chatsUnread: {},
    unreadTotal: 0,
});
